import { createRouteRef } from '@backstage/core-plugin-api';

export const adoptionRouteRef = createRouteRef({
  id: 'adoption',
});